import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS, ICONS } from 'src/common/constants';
import Tenant from '../../../../components/Tenant/Tenant';
import Avatar from '../../../../components/Avatar/Avatar';
import FontAwesomeIcon from '../../../../components/Icon';

const TypeaheadResult = ({ result, onClick }) => {
  switch (result.type) {
    case 'Contact':
      return result.data && result.data.length > 0
        ? result.data.map((contact: any) => (
            <Link
              className="typeahead__result"
              to={PATHS.CONTACTS_VIEW.replace(':id', contact.userId)}
              onClick={onClick}
            >
              <Tenant
                avatar={
                  <Avatar
                    size="medium"
                    url={
                      contact.profileImage !== null
                        ? contact.profileImage
                        : null
                    }
                    badge={ICONS[contact.type]}
                  />
                }
                headline={`${contact.firstname} ${contact.lastname}`}
              />
            </Link>
          ))
        : null;
    case 'Item':
      return result.data && result.data.length > 0
        ? result.data.map((item: any) => (
            <Link
              className="typeahead__result"
              to={PATHS.ITEMS_VIEW.replace(':id', item.id)}
              onClick={onClick}
            >
              <Tenant
                avatar={
                  <div className="typeahead__icon">
                    <FontAwesomeIcon glyph="boxes" weight="regular" />
                  </div>
                }
                headline={item.name}
                strapline={item.makeName}
              />
            </Link>
          ))
        : null;
    case 'Property':
      return result.data && result.data.length > 0
        ? result.data.map((property: any) => (
            <Link
              className="typeahead__result"
              to={PATHS.PROPERTIES_VIEW.replace(':id', property.id)}
              onClick={onClick}
            >
              <Tenant
                avatar={
                  <div className="typeahead__icon">
                    <FontAwesomeIcon glyph="building" weight="regular" />
                  </div>
                }
                headline={property.name}
                strapline={property.addressLine1}
              />
            </Link>
          ))
        : null;
    case 'Service Request':
      return result.data && result.data.length > 0
        ? result.data.map((serviceRequest: any) => (
            <Link
              className="typeahead__result"
              to={PATHS.SERVICE_REQUESTS_VIEW.replace(':id', serviceRequest.id)}
              onClick={onClick}
            >
              <Tenant
                avatar={
                  <div className="typeahead__icon">
                    <FontAwesomeIcon glyph="wrench" weight="regular" />
                  </div>
                }
                headline={serviceRequest.ticketId}
                strapline={serviceRequest.subject}
              />
            </Link>
          ))
        : null;
    default:
      return null;
  }
};

export default TypeaheadResult;
